import { useQuery } from "@tanstack/react-query";
import { mapSelectOptions } from "../../../utils/map4select";
import { FilterSelectOption } from "../../filters/filters.types";
import { exciseLicenceKeys } from "./exciseLicences.keys";
import { exciseLicencesService } from "./exciseLicences.service";
import {
  ExciseLicenceRequestListPayload,
  ExciseLicenceRequestListResponse,
} from "./exciseLicences.types";

/**
 * Hook used to fetch data for excise licence request list
 * @param filters Filters applied to table data
 * @param enabled If true API call is initiated immediately
 * @returns Filter dropdown values that can be applied to data and data after/before data
 */
export function useExciseLicenceRequestList({
  filters,
  enabled,
}: {
  filters: ExciseLicenceRequestListPayload;
  enabled?: boolean;
}) {
  return useQuery({
    ...exciseLicenceKeys.exciseLicenceRequestList({ filters }),
    queryFn: () => exciseLicencesService.getSviZahteviZaDozvolu(filters),
    select: (response): ExciseLicenceRequestListResponse => ({
      exciseLicenceRequestList: response?.data?.zahteviZaAkciznuDozvolu ?? [],
      productTypes: mapSelectOptions<FilterSelectOption>({
        labelAccessor: "name",
        valueAccessor: "id",
        sourceArray: response?.data?.vrsteFilters,
      }),
      requestTypes: mapSelectOptions<FilterSelectOption>({
        labelAccessor: "name",
        valueAccessor: "id",
        sourceArray: response?.data?.tipZahtevaFilters,
      }),
      statuses: mapSelectOptions<FilterSelectOption>({
        labelAccessor: "name",
        valueAccessor: "id",
        sourceArray: response?.data?.filteriZaStatus,
      }),
    }),
    retry: false,
    enabled,
  });
}
